module.exports = __webpack_public_path__ + "static/media/blue.63c4e415.png";